'use strict';


Object.defineProperty(exports, "__esModule", {
  value: true
});

const axios = require('axios');

exports.ClientApiModule = function(host){
	this.host = host;
	this.token = '';
	this.tokenTime = 0;
	this.tokenExpire = 0;	
	this.lang = 'en';
	this.loginObj = {level: 0};
	this.loginQueue = [];
	this.instance = axios.create({
      baseURL: this.host,
      timeout: 50000,
      responseType: 'json'
    });

//returning codes:
//900: OK
//901: unauthorized request
//904: not found
//905: network error
//906: internal error
//907: failed request
this.updateLang = function (lang) {
	this.lang = lang;
}
this.updateToken = function (tk, tkt, tke, loginObj) {
	if(tk != undefined && tk != null){
	this.token = tk;
	}
	if(tkt != undefined && tkt != null){
	this.tokenTime = tkt;
	}
	if(tke != undefined && tke != null){
	this.tokenExpire = tke;
	}
	this.loginQueue = [];
	if(loginObj != undefined && loginObj != null){
	this.loginObj = loginObj
	}
}

this.isTokenValid = function () {
	var t = this.tokenTime + this.tokenExpire;
	if((t === NaN || t == undefined || t == null) || (this.tokenTime == undefined || this.tokenExpire == undefined)){
		t = 0;
	}
	//console.log("a", Date.now() , this.tokenTime, this.tokenExpire);
	if(Math.round(Date.now() / 1000) >= t){
		return false;
	}else{
		return true;
	}
}
this.getLoginInfo = function (){	
return this.loginObj;
}
//add a callback function to call at successful login. this couls be anywhere, but be sure that the instance reference exists or is from a global object, if not, all will crash
this.addLoginQueueCallback = function (cb, bindObj, params){
	this.loginQueue.push({"cb": cb, "params": params, 'bindObj': bindObj});
}	
this.login = function (parameters, cb){	
  this.instance.post('/api/login', parameters)
  .then((response) => {
	  if( response.data.code == 900 ){
		  this.token = response.data.token;
		  this.tokenTime = Math.round(Date.now() / 1000);
		  this.tokenExpire = response.data.expire;
		  response.data.tokenTime = Math.round(Date.now() / 1000);
		  this.loginObj = response.data;
	  }	  
	  cb(response.data, true);
	  if(this.loginQueue.length > 0 && response.data.code == 900) {
		  for(var i = 0; i < this.loginQueue.length; i++) {
				if(this.loginQueue[i].cb != undefined) {
					
					 for(var h = 0; h < this.loginQueue[i].params.length; h++) {
						if(Array.isArray(this.loginQueue[i].params[h])){
						 for(var t = 0; t < this.loginQueue[i].params[h].length; t++){
							 this.loginQueue[i].params[h][t].replace(/\[TOKEN\]/g, this.token);
						 }	
						}else if( (typeof this.loginQueue[i].params[h] === "object") && (this.loginQueue[i].params[h] !== null) ) {
						 var objKeys = Object.keys(this.loginQueue[i].params[h]);
						 for(var t = 0; t < objKeys.length; t++){
							 if(this.loginQueue[i].params[h][objKeys[t]].replace != undefined){
							 this.loginQueue[i].params[h][objKeys[t]].replace(/\[TOKEN\]/g, this.token);
							}
						 }								
						}else{
							if(this.loginQueue[i].params[h] != null && this.loginQueue[i].params[h] != undefined){
							 if(this.loginQueue[i].params[h].replace != undefined){
							 this.loginQueue[i].params[h].replace(/\[TOKEN\]/g, this.token);							
							}
							}
						}						
					}
					this.loginQueue[i].cb.call(this.loginQueue[i].bindObj, ...this.loginQueue[i].params);
				}
		  }
	  }
  })
  .catch(function (error) {
    cb({code: 905}, true);
  });
}

this.register = function (parameters, cb, internalError){
  parameters = Object.assign(parameters, {'lang': this.lang});
  this.instance.post('/api/register', parameters)
  .then((response) => {
	  if( response.data.code == 900 ){
		  if(response.data.token != undefined){
		  this.token = response.data.token;
		  this.tokenTime = Date.now();
		  this.tokenExpire = response.data.expire;
		  response.data.tokenTime = Math.round(Date.now() / 1000);
		  this.loginObj = response.data;
		  }
	  cb(response.data, true);

	  if(this.loginQueue.length > 0 && response.data.code == 900) {
		  for(var i = 0; i < this.loginQueue.length; i++) {
				if(this.loginQueue[i].cb != undefined) {
					
					 for(var h = 0; h < this.loginQueue[i].params.length; h++) {
						if(Array.isArray(this.loginQueue[i].params[h])){
						 for(var t = 0; t < this.loginQueue[i].params[h].length; t++){
							 this.loginQueue[i].params[h][t].replace(/\[TOKEN\]/g, this.token);
						 }	
						}else if( (typeof this.loginQueue[i].params[h] === "object") && (this.loginQueue[i].params[h] !== null) ) {
						 var objKeys = Object.keys(this.loginQueue[i].params[h]);
						 for(var t = 0; t < objKeys.length; t++){
							 if(this.loginQueue[i].params[h][objKeys[t]].replace != undefined){
							 this.loginQueue[i].params[h][objKeys[t]].replace(/\[TOKEN\]/g, this.token);
							}
						 }								
						}else{
							if(this.loginQueue[i].params[h] != null && this.loginQueue[i].params[h] != undefined){
							 if(this.loginQueue[i].params[h].replace != undefined){
							 this.loginQueue[i].params[h].replace(/\[TOKEN\]/g, this.token);							
							}
							}
						}						
					}
					this.loginQueue[i].cb.call(this.loginQueue[i].bindObj, ...this.loginQueue[i].params);
				}
		  }
	  }

	  //something went wrong, parameters are not correct
	  }else if(response.data.code == 907){
      cb({code: 907, parameter: response.data.parameter, reason: response.data.reason}, true);		  
	  }else {
	  internalError(response.data);	  
	  }
  })
  .catch(function (error) {
    cb({code: 905}, true);
  });
}


this.genResetLink = function (email, cb){
  this.instance.post('/api/genResetLink', {"email":email, "lang":this.lang})
  .then((response) => {
	cb(response.data, true);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });	
}

this.resetPassword = function (token, password, cb) {
   this.instance.post('/api/resetPassword/'+token, {"password":password, "lang":this.lang})
  .then((response) => {
	cb(response.data, true);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });		
}

this.confirmUser = function(token, cb) {
   this.instance.get('/api/confirmUser/'+token)
  .then((response) => {
	cb(response.data, true);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });			
}

this.getUserInfo = function(cb) {
   this.instance.post('/api/auth/getUserInfo', {token: this.token})
  .then((response) => {
	cb(response.data);
	if(response.data.code == 901) {
		this.clearTokenData();
	}		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });			

}
this.updateInfo = function(data, cb){
   data.token = this.token;
   this.instance.post('/api/auth/updateInfo', data)
  .then((response) => {
	cb(response.data, true);		  
	if(response.data.code == 901) {
		this.clearTokenData();
	}		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });			
}

this.callService =  async function (service, parameters, cb, uploadProgress, hasFiles){
	var makeFormData = false;
	var config = {}, data = parameters;
	for ( var k in parameters ) {
		if(parameters[k].indexOf != undefined){
		if(parameters[k].indexOf('base64')!== -1 && hasFiles != false){
			parameters[k] = this.base64ToFile(parameters[k]);			
			//makeFormData = true;
		}
		}
	}
  parameters.token = this.token;
	if((uploadProgress != undefined && uploadProgress != null) || hasFiles) {
	data = new FormData();
	var fileNames  = [];
	  for ( var k in parameters ) {
		  if(parameters[k].type == 'files'){
			for ( var k2 in parameters[k].f ) {
				//for the stupid ios and multer combination, sending a backup of filenames in the request, as originalname is not populated
				if (parameters[k].f[k2].name != null && parameters[k].f[k2].name != undefined) {
					fileNames.push(parameters[k].f[k2].name);	
				} else {
					fileNames.push(0);
				}
				if(parameters[k].f[k2].indexOf!=undefined && parameters[k].f[k2].indexOf!=null){
					if(parameters[k].f[k2].indexOf('base64')!== -1){
						parameters[k].f[k2] = this.base64ToFile(parameters[k].f[k2]);									
					}
				}
				data.append(k, parameters[k].f[k2]);
			}
			data.append('filenames', JSON.stringify(fileNames));			  
		  }else{
		  data.append(k, parameters[k]);
			}
		  }
	config = {
  headers: { 'Content-Type': 'multipart/form-data' }
	}	
	if(uploadProgress != undefined && uploadProgress != null) {  
	config.onUploadProgress = uploadProgress;
	}
	}
	if(cb == 'sync'){
//return async () => {
		try {

 var response = await this.instance.post('/'+service, data, config);
 if(response.data.code == 901) {
		this.clearTokenData();
	}
	return response.data;			
		}catch (error) {
    return {code: 905};
}
//}
	}else {
  this.instance.post('/'+service, data, config)
  .then((response) => {
	  if(cb!=null && cb!=undefined){
	  cb(response.data);
	  if(response.data.code == 901) {
		this.clearTokenData();
	  }		  
	  }
  })
  .catch(function (error) {
	  //console.log("error uploadtemp = ", error);
	if(cb!=null && cb!=undefined){
	  cb({code: 905});
	}
  });
	}
}

this.base64ToFile = function(data) {	
	var byteString = atob(data.split(',')[1])

    var mimeString = data.split(',')[0].split(':')[1].split(';')[0]

    var ab = new ArrayBuffer(byteString.length)
    var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
         ia[i] = byteString.charCodeAt(i)
      }
	return new File([ab], Date.now() + "." + this.mimeToExtension(mimeString), { type: mimeString })
}
this.clearTokenData = function (){
		  this.token = '';
		  this.tokenTime = 0;
		  this.tokenExpire = '';
		  this.loginObj = {level: 0};
}
this.mimeToExtension = function(mime){
	
var types = [
    "text/html", "html", 
    "text/css", "css", 
    "text/xml", "xml", 
    "image/gif", "gif", 
    "image/jpeg", "jpg", 
    "application/x-javascript",  "js",
    "application/atom+xml", "atom",
    "application/rss+xml", "rss",
    "text/mathml", "mml",
    "text/plain",  "txt",
    "text/vnd.wap.wml", "wml",
    "text/x-component", "htc",
    "image/png", "png",
    "image/tiff", "tiff",
    "image/x-icon", "ico",
    "image/x-jng", "jng",
    "image/x-ms-bmp", "bmp",
    "image/svg+xml", "svg",
    "image/webp", "webp",
    "application/java-archive", "jar",
    "application/msword", "doc",
    "application/pdf", "pdf",
    "application/postscript", "eps",
    "application/rtf ", "rtf",
    "application/vnd.ms-excel", "xls",
    "application/vnd.ms-powerpoint", "ppt",
    "application/x-7z-compressed", "7z",
    "application/x-rar-compressed", "rar",
    "application/zip", "zip",
    "application/octet-stream", "iso",
    "audio/midi", "midi",
    "audio/mpeg", "mp3",
    "audio/ogg", "ogg",
    "video/3gpp", "3gp",
    "video/mpeg", "mpeg",
    "video/quicktime", "mov",
    "video/x-flv", "flv",
    "video/x-mng", "mng",
    "video/x-ms-asf", "asx",
    "video/x-ms-wmv", "wmv",
    "video/x-msvideo", "avi",
    "video/mp4", "mp4"
]
var index = types.indexOf(mime);
if(index > -1) {
	return types[index + 1];
}else{
	return "none";
}
	
}
	
};
